import { Badge } from "@chakra-ui/react";

const NoProductsBadge = () => {
  return (
    <Badge colorScheme="green" p={4} m={4}>
      No products to show
    </Badge>
  );
};

export default NoProductsBadge;
